import React, { useEffect, useState } from "react"
import {
    Row,
    Col,
    Card,
    CardBody,
    CardTitle,
    Table,
    Badge,
    Button,
    Input,
} from "reactstrap"
import { connect } from "react-redux"
import { setBreadcrumbItems } from "../../store/actions"
import { pointsAPI } from "../../services/api"

const PointHistory = (props) => {
    document.title = "Historique des Points | Ticket Management"

    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const isManagerOrAdmin = ['manager', 'admin'].includes(user.role);
    const isAdmin = user.role === 'admin';

    const [history, setHistory] = useState([])
    const [totalPoints, setTotalPoints] = useState(0)
    const [currentLevel, setCurrentLevel] = useState(1)
    const [teamHistory, setTeamHistory] = useState([])
    const [settings, setSettings] = useState([])
    const [loading, setLoading] = useState(true)
    const [editingId, setEditingId] = useState(null)
    const [editValue, setEditValue] = useState("")

    const breadcrumbItems = [
        { title: "Dashboard", link: "/dashboard" },
        { title: "Points de récompense", link: "#" },
    ]

    useEffect(() => {
        props.setBreadcrumbItems("Points de récompense", breadcrumbItems)
        fetchData()
    }, [])

    const fetchData = async () => {
        setLoading(true)
        try {
            // Fetch point coefficients
            const settingsRes = await pointsAPI.getSettings()
            setSettings(settingsRes.data)

            if (!isAdmin) {
                const res = await pointsAPI.getHistory()
                setHistory(res.data.history)
                setTotalPoints(res.data.total_points)
                setCurrentLevel(res.data.level || 1)
            }

            if (isManagerOrAdmin) {
                const teamRes = await pointsAPI.getTeamHistory()
                setTeamHistory(teamRes.data)
            }
        } catch (error) {
            console.error("Erreur lors du chargement des points", error)
        } finally {
            setLoading(false)
        }
    }

    const handleUpdateSetting = async (id) => {
        try {
            await pointsAPI.updateSetting(id, editValue)
            setEditingId(null)
            fetchData()
        } catch (error) {
            console.error("Erreur lors de la mise à jour du coefficient", error)
        }
    }


    return (
        <React.Fragment>
            {isAdmin && (
                <Row>
                    <Col md={12}>
                        <Card>
                            <CardBody>
                                <CardTitle className="h4 mb-4">Configuration des Coefficients</CardTitle>
                                <p className="text-muted">Modifier les taux de conversion des points en DH selon le type de projet.</p>
                                <Row>
                                    {settings.map((setting) => (
                                        <Col md={6} key={setting.id}>
                                            <div className="p-3 border rounded mb-3 bg-light">
                                                <h6>{setting.label}</h6>
                                                <p className="small text-muted mb-2">{setting.description}</p>
                                                <div className="d-flex align-items-center">
                                                    {editingId === setting.id ? (
                                                        <>
                                                            <Input
                                                                type="number"
                                                                step="0.1"
                                                                value={editValue}
                                                                onChange={(e) => setEditValue(e.target.value)}
                                                                className="me-2"
                                                                style={{ width: '120px' }}
                                                            />
                                                            <Button color="success" size="sm" onClick={() => handleUpdateSetting(setting.id)}>Enregistrer</Button>
                                                            <Button color="secondary" size="sm" className="ms-1" onClick={() => setEditingId(null)}>Annuler</Button>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <h4 className="mb-0 me-3 text-primary">{setting.value} DH</h4>
                                                            <Button
                                                                color="info"
                                                                outline
                                                                size="sm"
                                                                onClick={() => {
                                                                    setEditingId(setting.id);
                                                                    setEditValue(setting.value);
                                                                }}
                                                            >
                                                                Modifier
                                                            </Button>
                                                        </>
                                                    )}
                                                </div>
                                            </div>
                                        </Col>
                                    ))}
                                </Row>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            )}

            {!isAdmin && (
                <>
                    <Row>
                        <Col md={12}>
                            <Card className="bg-primary text-white-50">
                                <CardBody>
                                    <div className="d-flex align-items-center">
                                        <div className="flex-grow-1">
                                            <h5 className="text-white">Mes Points Total</h5>
                                            <div className="d-flex align-items-center">
                                                <h2 className="text-white mb-0 me-3">{totalPoints} Points</h2>
                                                <Badge color="info" className="font-size-14">
                                                    Level {currentLevel}
                                                </Badge>
                                            </div>
                                        </div>
                                        <div className="avatar-sm">
                                            <span className="avatar-title bg-soft-light rounded-circle font-size-24">
                                                <i className="mdi mdi-star text-white"></i>
                                            </span>
                                        </div>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={12}>
                            <Card>
                                <CardBody>
                                    <CardTitle className="h4 mb-4">Mon Historique de Points</CardTitle>
                                    <div className="table-responsive">
                                        <Table className="table-centered table-nowrap mb-0">
                                            <thead className="thead-light">
                                                <tr>
                                                    <th>Date</th>
                                                    <th>Ticket</th>
                                                    <th>Projet</th>
                                                    <th>Points</th>
                                                    <th>Valeur (DH)</th>
                                                    <th>Description</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {history.length > 0 ? history.map((item, index) => {
                                                    const isInterne = item.ticket?.projet?.type === 'interne';
                                                    const valeurDH = item.valeur_dh || 0;

                                                    return (
                                                        <tr key={index}>
                                                            <td>{new Date(item.created_at).toLocaleString()}</td>
                                                            <td>{item.ticket ? item.ticket.titre : 'Ticket supprimé'}</td>
                                                            <td>
                                                                <Badge color={isInterne ? "soft-info" : "soft-warning"} className="border">
                                                                    {item.ticket?.projet?.nom || 'N/A'}
                                                                </Badge>
                                                            </td>
                                                            <td>
                                                                <span className="badge bg-success">+{item.points}</span>
                                                            </td>
                                                            <td className="fw-bold text-primary">
                                                                {valeurDH.toLocaleString()} DH
                                                            </td>
                                                            <td>{item.description}</td>
                                                        </tr>
                                                    )
                                                }) : (
                                                    <tr>
                                                        <td colSpan="6" className="text-center">Aucun historique de points trouvé.</td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </Table>
                                    </div>
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </>
            )}

            {isManagerOrAdmin && (
                <Row>
                    <Col md={12}>
                        <Card>
                            <CardBody>
                                <CardTitle className="h4 mb-4">Historique des Points de l'Équipe</CardTitle>
                                <div className="table-responsive">
                                    <Table className="table-centered table-nowrap mb-0">
                                        <thead className="thead-light">
                                            <tr>
                                                <th>Collaborateur</th>
                                                <th>Date</th>
                                                <th>Ticket</th>
                                                <th>Points</th>
                                                <th>Valeur (DH)</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {teamHistory.length > 0 ? teamHistory.map((item, index) => {
                                                const isInterne = item.ticket?.projet?.type === 'interne';
                                                const valeurDH = item.valeur_dh || 0;

                                                return (
                                                    <tr key={index}>
                                                        <td>
                                                            <div className="d-flex align-items-center">
                                                                <div className="flex-grow-1">
                                                                    <h5 className="font-size-14 mb-0">{item.user?.name}</h5>
                                                                    <p className="text-muted mb-0">{item.user?.email}</p>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        <td>{new Date(item.created_at).toLocaleString()}</td>
                                                        <td>
                                                            {item.ticket ? item.ticket.titre : 'Ticket supprimé'}
                                                            <br />
                                                            <small className="text-muted">
                                                                Projet: {item.ticket?.projet?.nom}
                                                            </small>
                                                        </td>
                                                        <td>
                                                            <span className="badge bg-success">+{item.points}</span>
                                                        </td>
                                                        <td className="fw-bold text-primary">
                                                            {valeurDH.toLocaleString()} DH
                                                        </td>
                                                    </tr>
                                                )
                                            }) : (
                                                <tr>
                                                    <td colSpan="5" className="text-center">Aucun historique d'équipe trouvé.</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            )}
        </React.Fragment>
    )
}

export default connect(null, { setBreadcrumbItems })(PointHistory)
